import React, { FC, memo } from 'react';
// import useWindowSize from '../../../../hooks/useWindowSize';
// import MenuBar from './MenuBar/MyPageMenuBar.index';

type Props = {
  children?: React.ReactNode;
};

const Footer: FC<Props> = ({ children }) => {
  // const getIsMobile = () => window.innerWidth < 576;
  // const isMobile = useWindowSize(getIsMobile);

  return (
    <>
      <footer>
        <div className="layout">
          <div>
            <p className="title">
              <img src="/images/logo2.svg?hc=q6710i" alt="Footer logo" />
            </p>
          </div>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 448 512"
            width="1em"
            strokeWidth="0"
            fill="currentColor"
            stroke="currentColor"
            className="footer-arrow-icon"
            height="1em"
          >
            <path d="M240.971 130.524l194.343 194.343c9.373 9.373 9.373 24.569 0 33.941l-22.667 22.667c-9.357 9.357-24.522 9.375-33.901.04L224 227.495 69.255 381.516c-9.379 9.335-24.544 9.317-33.901-.04l-22.667-22.667c-9.373-9.373-9.373-24.569 0-33.941L207.03 130.525c9.372-9.373 24.568-9.373 33.941-.001z" />
          </svg>
        </div>
      </footer>
    </>
  );
};

Footer.defaultProps = {
  children: undefined,
};

export default memo(Footer);
